import * as z from "zod";

export const serverResponse = z.array(
  z
    .object({
      geographicalAddress: z
        .object({
          municipality: z.string().optional(),
          street: z.string().optional(),
          streetNumber: z.string().optional(),
          apartmentNumber: z.string().optional(),
        })
        .optional(),
      CBSReference: z
        .object({
          municipalityId: z.number().optional(),
          streetId: z.number().optional(),
        })
        .optional(),
      type: z.string().optional(),
    })
    .optional(),
);
